import { apiInstance } from '../api';

// «Акции» of the portal (express controllers/promotions)
export class PromotionsService {
  // all of them, with deadline and shownNow
  static async fetchAll() {
    return apiInstance.get('/promotions/admin')
  }

  static async save(id, values) {
    return id ? apiInstance.put(`/promotions/${id}`, values) : apiInstance.post('/promotions', values)
  }

  static async remove(id) {
    return apiInstance.delete(`/promotions/${id}`)
  }

  static async uploadImage(id, file) {
    const formData = new FormData()
    formData.append('file', file)
    return apiInstance.post(`/promotions/${id}/image`, formData)
  }
}
